import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

// Response shape from GET /api/v3/sensors/:id/notes
export interface SensorNote {
  user?: { firstname?: string; lastname?: string } | null;
  comment?: string;
  createdAt?: string;
}

export const sensorNoteKeys = {
  all: ['sensor-notes'] as const,
  list: (id: string) => [...sensorNoteKeys.all, id] as const,
};

export function useSensorNotes(mongoId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: sensorNoteKeys.list(mongoId ?? ''),
    queryFn: async (): Promise<SensorNote[]> => {
      if (!mongoId) return [];
      try {
        const rows = await api.get<SensorNote[]>(`/v3/sensors/${mongoId}/notes`);
        return Array.isArray(rows) ? rows : [];
      } catch {
        // Degrade gracefully if endpoint unavailable in dev.
        return [];
      }
    },
    enabled: enabled && !!mongoId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
